<!-- 员工 -->
<template>
  <div class="app-container">
    <el-row :gutter="10">
            <dynamic-split-pane :default-percent="18"> -->
                <template v-slot:left>
                    <el-col>
                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <span>组织</span>
                            </div>
                            <div>
                                <el-input
                                    v-model="deptName"
                                    clearable
                                    placeholder="输入部门名称搜索"
                                    prefix-icon="el-icon-search"
                                    class="filter-item"
                                    @input="searchDept"/>
                                <div class="tree-container-scroll">
                                    <el-scrollbar>
                                        <tree
                                            class="org-tree"
                                            ref="orgTree"
                                            keyField="id"
                                            :data="treeData"
                                            :prop="treeProps"
                                            :expand-on-click-node="false"
                                            :filter-node="filterNode"
                                            @change="change"/>
                                    </el-scrollbar>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </template>
                <template v-slot:right>
                    <el-col>
                        <el-card class="box-card">
													<!-- 搜索-->
													<dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch" >
														<template v-slot:next>
														<el-button icon="el-icon-plus" @click="$router.push('/person/form')">新增</el-button>
														</template>
													</dynamic-search>
													<edit-data-table
														:head="tableHead"
														:data.sync="list"
														:editable="false"
														:total="total"
														:offset="offset"
														:page="page"
														:loading="loading"
														stripe
														@handlePageChange="dataTablePageChange"
														@handleSizeChange="dataTableSizeChange"
													>
														<template #toolbar="scope">
														<el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
														<el-popover :ref="scope.row.id" placement="top" width="180">
															<p>确定删除本条数据吗？</p>
															<div style="text-align: right; margin: 0">
															<el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
															<el-button
																type="primary"
																size="mini"
																@click="subDelete(scope.row.id)"
															>确定</el-button>
															</div>
															<el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
														</el-popover>
														</template>
													</edit-data-table>
												</el-card>
                    </el-col>
                </template> -->
            </dynamic-split-pane>
        </el-row>
  </div>
</template>

<script>
import Tree from "@/components/Tree/index.vue";
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DynamicSplitPane from "@/components/DynamicSplitPane/index.vue";
import DataTableMixin from "@/mixins/DataTableMixin";
import {getDeptTree} from "@/api/dept";
import { delPerson } from "@/api/basic";
export default {
  name: "Person",
  directives: {},
  filters: {},
  mixins: [DataTableMixin],
  props: {},
  components: {
	DynamicSearch,
	Tree,
	DynamicSplitPane
  },
  data() {
    return {
      isAdd: false,
      tableHead: [
        {
          label: "工号",
          prop: "code",
          align: "left"
        },
        {
          label: "姓名",
          prop: "name",
          query: {
            type: "input"
          }
        },
        {
          label: "联系电话",
          prop: "telephone"
        },
        {
          label: "职级",
          prop: "rankName",
        },
        {
          label: "部门",
          prop: "departmentName",
        }
      ],
			list: [],
			treeData: [],
			treeProps: {
				children: "children",
				label: "name"
			},
			deptId: "",
			deptName: ""
    };
  },
  computed: {},
  watch: {},
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
			this.dataTableInit();
			this.getDeptTree();
    });
  },
  methods: {
		getDeptTree() {
			getDeptTree().then(res => {
				this.treeData = res.data || []
			});
		},
		change(data) {
			if (data.pid === 0) {
				this.deptId = null;
			} else {
				this.deptId = data.id;
			}
			this.dataTableInit()
		},
		searchDept() {
			this.$refs.orgTree.$refs.tree.filter(this.deptName);
		},
		filterNode(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
		},
    dataTableBeforeInit() {
      this._url = "/bs-person/getList";
      const params = { page: this.page, size: this.offset, deptId: this.deptId, };
      this._params = Object.assign(params, this._query);
      return true;
    },
    dynamicSearch() {

    },
    edit(row) {
      console.log(row);
      this.$router.push("/person/form?id=" + row.id);
    },
    // 删除
    subDelete(id) {
      console.log(id);
      delPerson(id).then(res => {
        console.log(res);
          this.dataTableInit();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
      });
    }
  }
};
</script>

<style scoped>
</style>
